import { IntlTranslator } from 'page-components/provider/IntlGlobalProvider';

// 'intl' service singleton reference
export const intl = new IntlTranslator();
